import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link, NavLink, useLocation
} from "react-router-dom";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import axios from 'axios';
import baseUrl from "../../../../utils/Constants";
import "../TabContentStyles.css";
import { Breadcrumbs } from "@material-ui/core";
import CyberDefense from "./CyberDefense/CyberDefense";
import CyberResponse from "./CyberResponse/CyberResponse";
import TechCloudFirstSecurity from "./TechCloudFirstSecurity/TechCloudFirstSecurity";
import TechCyberReadiness from "./TechCyberReadiness/TechCyberReadiness";
import TechDetectionResponse from "./TechDetectionResponse/TechDetectionResponse";
import ThreatIntelligence from "./ThreatIntelligence/ThreatIntelligence";


function CyberResilienceTab() {
    const location = useLocation();
    const propsData = location.state ? location.state.tabID : null;
    const [displaySkill, setDisplaySkill] = useState('CyberDefense');
    const [defence, setdefence] = useState([]);
    const [response, setresponse] = useState([]);
    const [cloudfirstsec, setcloudfirstsec] = useState([]);
    const [readiness, setreadiness] = useState([]);
    const [detection, setdetection] = useState([]);
    const [intelligence, setIntelligence] = useState('CyberDefense');

            const getCyberResilience = async () => {
        
             const response = await axios.get(`${baseUrl}/cyberresilience`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token")
              }
            }
            ).then(res => {
              console.log("getall", res);
              if(res.data.result.length > 0){
        
                const arr = res.data.result;
                setdefence(arr.filter((item) => item.sub_practice.includes("Defense")));
                setresponse(arr.filter((item) => item.sub_practice.includes("Cyber Response")));
                setcloudfirstsec(arr.filter((item) => item.sub_practice.includes("Cloud Security")));
                setreadiness(arr.filter((item) => item.sub_practice.includes("Readiness")));
                setdetection(arr.filter((item) => item.sub_practice.includes("Detection")));
                setIntelligence(arr.filter((item) => item.sub_practice.includes("Threat Intelligence")));

              }
              // setAllbooks(res.data.result);
              
              return res.data
            }).catch(err => {console.log("error")});
        
          }
        
            useEffect(() => {
                getCyberResilience();
            }, [])

    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            Cyber Resilience
                        </NavLink>
                        {displaySkill === "CyberDefense" ? (
                            <NavLink className="menu_title" to="/CyberResilienceNew#CyberDefense">
                                Cyber Defense
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "CyberResponse" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberResilienceNew#CyberResponse"
                            >
                                Cyber Response
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "TechCloudFirstSecurity" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberResilienceNew#TechCloudFirstSecurity"
                            >
                                Tech_Cloud First Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "TechCyberReadiness" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberResilienceNew#TechCyberReadiness"
                            >
                                Tech_Cyber Readiness
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "TechDetectionResponse" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberResilienceNew#TechDetectionResponse"
                            >
                                Tech_Detection & Response
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "ThreatIntelligence" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberResilienceNew#ThreatIntelligence"
                            >
                                Threat Intelligence
                            </NavLink>
                        ) : (
                            ""
                        )}
                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={
                            displaySkill === "CyberDefense" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => setDisplaySkill("CyberDefense")}
                        href="#CyberDefense"
                    >
                        <span>Cyber Defense</span>
                    </a>
                    <a
                        className={
                            displaySkill === "CyberResponse" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("CyberResponse");
                        }}
                        href="#CyberResponse"
                    >
                        <span>Cyber Response</span>
                    </a>
                    <a
                        className={
                            displaySkill === "TechCloudFirstSecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("TechCloudFirstSecurity");
                        }}
                        href="#TechCloudFirstSecurity"
                    >
                        <span>Tech_Cloud First Security</span>
                    </a>
                    <a
                        className={
                            displaySkill === "TechCyberReadiness" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("TechCyberReadiness");
                        }}
                        href="#TechCyberReadiness"
                    >
                        <span>Tech_Cyber Readiness</span>
                    </a>
                    <a
                        className={
                            displaySkill === "TechDetectionResponse" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("TechDetectionResponse");
                        }}
                        href="#TechDetectionResponse"
                    >
                        <span>Tech_Detection & Response</span>
                    </a>
                    <a
                        className={
                            displaySkill === "ThreatIntelligence" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("ThreatIntelligence");
                        }}
                        href="#ThreatIntelligence"
                    >
                        <span>Threat Intelligence</span>
                    </a>

                </div>
                <div className="TabPanel-Wrap">
                    {displaySkill === "CyberDefense" ? (
                        <CyberDefense defence = {defence}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "CyberResponse" ? (
                        <CyberResponse response = {response}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "TechCloudFirstSecurity" ? (
                        <TechCloudFirstSecurity cloudfirstsec = {cloudfirstsec}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "TechCyberReadiness" ? (
                        <TechCyberReadiness readiness = {readiness}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "TechDetectionResponse" ? (
                       <TechDetectionResponse detection = {detection}/>
                    ) : (
                        ""
                    )}

                    {displaySkill === "ThreatIntelligence" ? (
                        <ThreatIntelligence intelligence = {intelligence}/>
                    ) : (
                        ""
                    )}

                </div>
            </div>
        </>
    );
}

export default CyberResilienceTab;